import { components } from "react-select";
import Tooltip from "../Tooltip";
import ImageContent from "./ImageContent";
import { formatAmount, getPriceCurrency } from "../../utils/priceHelper";

const Option = (props) => {
  const { rawData } = props.data;
  const { isFocused, options } = props;
  const currency = getPriceCurrency(rawData, true);

  return (
    <Tooltip
      show={isFocused}
      content={
        <div className="tw-w-52 tw-text-center tw-px-4 tw-py-4">
          <span className="tw-uppercase">
            {rawData.itemBrand} {rawData.itemClassId}
          </span>
          <p className="tw-font-bold">{rawData.modelSize}</p>
          {rawData?.itemPrices && (
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
              {rawData.itemPrices.isDiscounted ? (
                <table className="tw-w-full tw-text-sm">
                  <tbody>
                    <tr>
                      <td className="tw-text-left">Price:</td>
                      <td className="tw-font-bold tw-text-right">
                        {currency + formatAmount(rawData.itemPrices.listPrice)}
                      </td>
                    </tr>
                    <tr>
                      <td className="tw-text-left">Discount:</td>
                      <td className="tw-font-bold tw-text-right">
                        {currency +
                          formatAmount(rawData.itemPrices.discountAmount)}
                      </td>
                    </tr>
                    <tr className="tw-border-t">
                      <td className="tw-text-left">Net:</td>
                      <td className="tw-font-bold tw-text-right">
                        {currency + formatAmount(rawData.itemPrices.amount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <table className="tw-w-full tw-text-sm">
                  <tbody>
                    <tr>
                      <td className="tw-text-left">Price per unit:</td>
                      <td className="tw-font-bold tw-text-right">
                        {currency + formatAmount(rawData.itemPrices.amount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          )}

          <div className="tw-relative tw-w-full" style={{ height: "160px" }}>
            {isFocused && (
              <ImageContent
                itemId={rawData.itemId}
                mediaUrl={rawData.mediaUrl}
                options={options}
              />
            )}
          </div>
        </div>
      }
      config={{
        zIndex: "99",
        theme: "light",
        trigger: "manual",
        placement: "right",
      }}
    >
      <div>
        <components.Option {...props} />
      </div>
    </Tooltip>
  );
};

export default Option;
